import type { Moment } from "moment-timezone";
import type { Nullable } from "../types";

interface TicketWithDates {
	state: string;
	startDate?: number | string | null;
	endDate?: number | string | null;
	[key: string]: unknown;
}

interface ProjectWithTickets {
	_tickets: TicketWithDates[];
	[key: string]: unknown;
}

function isTicketInWeek(ticket: TicketWithDates, weekStart: number, weekEnd: number): boolean {
	if (ticket.state !== "active") return false;
	const start = ticket.startDate != null ? +ticket.startDate : null;
	const end = ticket.endDate != null ? +ticket.endDate : null;
	if (start !== null && start > weekEnd) return false;
	if (end !== null && end < weekStart) return false;
	return true;
}

export function filterProjectsByWeek<T extends ProjectWithTickets>(
	projects: T[],
	week: Nullable<Moment>,
): T[] {
	if (!week) {
		return projects.map((project) => ({
			...project,
			_tickets: project._tickets.filter((t) => t.state === "active"),
		}));
	}

	const weekStart = week.clone().startOf("isoWeek").valueOf();
	const weekEnd = week.clone().endOf("isoWeek").valueOf();

	return projects
		.map((project) => ({
			...project,
			_tickets: project._tickets.filter((ticket) => isTicketInWeek(ticket, weekStart, weekEnd)),
		}))
		.filter((project) => project._tickets.length > 0);
}
